export const initialState = {
  activeModal: '',
  data: {},
  currentStep: 'default',
  modalId: '',
  previousSteps: [],
  requestInFlight: false,
  stepsData: [],
  errors: [],
};

const connectedModalReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        ...state,
        activeModal: action.name,
        data: action.data,
        modalId: action.modalId,
      };
    case 'CLOSE_MODAL':
      return initialState;
    case 'ADD_MODAL_DATA': {
      return {
        ...state,
        data: { ...state.data, ...action.data },
      };
    }
    case 'GO_TO_PREVIOUS_MODAL_STEP': {
      const previousSteps = [...state.previousSteps];
      const stepsData = [...state.stepsData];

      return {
        ...state,
        currentStep: previousSteps.pop() ?? initialState.currentStep,
        data: stepsData.pop() ?? initialState.data,
        previousSteps,
        stepsData,
      };
    }
    case 'GO_TO_MODAL_STEP':
      return {
        ...state,
        currentStep: action.nextStep,
        data: action.data,
        previousSteps: [...state.previousSteps, state.currentStep],
        stepsData: [...state.stepsData, state.data],
      };
    case 'MODAL_ACTION_REQUEST':
      return {
        ...state,
        requestInFlight: true,
        errors: [],
      };
    case 'MODAL_ACTION_SUCCESS':
      return {
        ...state,
        requestInFlight: false,
      };
    case 'MODAL_ACTION_FAILURE':
      return {
        ...state,
        errors: action.error,
        requestInFlight: false,
      };
    default:
      return state;
  }
};

export default connectedModalReducer;
